import { NavLink, Link } from "react-router-dom"

import { Icon } from "components/index"
import { Analytics } from "utils/analytics"
import { Text } from "@components-branded/Text"
import { GiftLink } from "components/Header/components/GiftLink"
import { TheDot } from "components/Header/components/TheDot/TheDot"
import { DesktopNavigation } from "components/Header"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
import { BLOG_URL, APP_PAGE_URL } from "utils/env-management"

export function MenuDesktop({ hide }: { hide?: boolean | null }) {
    const [{ userAccount }] = useClientContext()
    return (
        <>
            {!hide && (
                <DesktopNavigation.Menu>
                    <DesktopNavigation.Item primary>
                        <NavLink
                            className={({ isActive }) => (isActive ? "is-active" : "")}
                            to="/my/alter"
                            onClick={() => {
                                Analytics.go_to_my_alter()
                            }}
                        >
                            Мой Alter
                        </NavLink>
                    </DesktopNavigation.Item>
                    <DesktopNavigation.Item>
                        <NavLink
                            className={({ isActive }) => (isActive ? "is-active" : "")}
                            to="/my/sessions"
                            onClick={() => {
                                Analytics.go_to_sessions()
                            }}
                        >
                            Сессии
                        </NavLink>
                    </DesktopNavigation.Item>
                    <DesktopNavigation.Item>
                        <NavLink
                            className={({ isActive }) => (isActive ? "is-active" : "")}
                            to="/my/selections"
                            onClick={() => {
                                Analytics.go_to_selections()
                            }}
                        >
                            Подборки
                        </NavLink>
                    </DesktopNavigation.Item>
                    <DesktopNavigation.Item submenu>
                        Еще <Icon type="arrow-down-dark" />
                        <DesktopNavigation.Submenu>
                            <DesktopNavigation.SubmenuSpecial>
                                {userAccount.is_hr && (
                                    <>
                                        <Link
                                            to="/my/statistics"
                                            className="restore-link-hover-color"
                                        >
                                            <Text isAccent>Личный кабинет HR</Text>
                                        </Link>{" "}
                                        <TheDot />
                                    </>
                                )}
                                <GiftLink isHoverable />
                            </DesktopNavigation.SubmenuSpecial>
                            <DesktopNavigation.SubmenuDivider />
                            <DesktopNavigation.SubmenuColumns>
                                <DesktopNavigation.SubmenuColumn>
                                    <DesktopNavigation.SubmenuHeader>
                                        ЗНАНИЯ
                                    </DesktopNavigation.SubmenuHeader>
                                    <DesktopNavigation.SubmenuItem primary>
                                        <a href={`${APP_PAGE_URL}/guide`}>
                                            Гид по&nbsp;психотерапии
                                        </a>
                                    </DesktopNavigation.SubmenuItem>
                                    <DesktopNavigation.SubmenuItem primary>
                                        <a href={`${BLOG_URL}/`}>Блог</a>
                                    </DesktopNavigation.SubmenuItem>
                                    <DesktopNavigation.SubmenuItem primary>
                                        <a
                                            href={`${BLOG_URL}/likbez/chego-ozhidat-ot-psihoterapii/`}
                                        >
                                            Что ожидать от&nbsp;терапии
                                        </a>
                                    </DesktopNavigation.SubmenuItem>
                                    <DesktopNavigation.SubmenuItem primary>
                                        <a href={`${APP_PAGE_URL}/podcast`}>Подкасты Alter</a>
                                    </DesktopNavigation.SubmenuItem>
                                    <DesktopNavigation.SubmenuItem primary>
                                        <a href="https://stepik.org/course/60641/promo">
                                            Онлайн-курс о&nbsp;терапии
                                        </a>
                                    </DesktopNavigation.SubmenuItem>
                                </DesktopNavigation.SubmenuColumn>
                                <DesktopNavigation.SubmenuColumn>
                                    <DesktopNavigation.SubmenuHeader>
                                        О&nbsp;НАС
                                    </DesktopNavigation.SubmenuHeader>
                                    <DesktopNavigation.SubmenuItem primary>
                                        <a href={`${APP_PAGE_URL}/about`}>О&nbsp;сервисе</a>
                                    </DesktopNavigation.SubmenuItem>
                                    <DesktopNavigation.SubmenuItem primary>
                                        <a href={`${APP_PAGE_URL}/faq`}>Вопросы и&nbsp;ответы</a>
                                    </DesktopNavigation.SubmenuItem>
                                    <DesktopNavigation.SubmenuBlockDivider />
                                    <DesktopNavigation.SubmenuItem>
                                        <Link to="/survey/psy">Подобрать психолога</Link>
                                    </DesktopNavigation.SubmenuItem>
                                    <DesktopNavigation.SubmenuItem>
                                        <Link to="/psychologists">Каталог психологов</Link>
                                    </DesktopNavigation.SubmenuItem>
                                    <DesktopNavigation.SubmenuItem>
                                        <a href={`${APP_PAGE_URL}/for-psychologists`}>Психологам</a>
                                    </DesktopNavigation.SubmenuItem>
                                    <DesktopNavigation.SubmenuItem>
                                        <a href={`${APP_PAGE_URL}/business`}>Бизнесу</a>
                                    </DesktopNavigation.SubmenuItem>
                                </DesktopNavigation.SubmenuColumn>
                            </DesktopNavigation.SubmenuColumns>
                        </DesktopNavigation.Submenu>
                    </DesktopNavigation.Item>
                </DesktopNavigation.Menu>
            )}
        </>
    )
}
